import React from "react";
import { TERMS_VERSION } from "../../common/constants";
import logo from "../../assets/logo_round.png";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        backgroundColor: "#f5f7fb",
        minHeight: "100vh",
        padding: "60px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          lineHeight: "1.8",
          color: "#333",
        }}
      >
        {/* Brand Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            marginBottom: "24px",
            paddingBottom: "20px",
            borderBottom: "1px solid #eee",
          }}
        >
          <img
            src={logo}
            alt="Speak Bold with KK Logo"
            style={{
              width: "56px",
              height: "56px",
              objectFit: "contain",
              borderRadius: "10px",
              backgroundColor: "#fff",
            }}
          />

          <div>
            <div
              style={{
                fontSize: "1.25rem",
                fontWeight: "700",
                color: "#111",
                lineHeight: "1.2",
              }}
            >
              Speak Bold with KK
            </div>

            <div
              style={{
                fontSize: "0.95rem",
                color: "#666",
                marginTop: "4px",
              }}
            >
              Learn confidently. Speak boldly.
            </div>
          </div>
        </div>

        {/* Header */}
        <h1
          style={{
            marginBottom: "10px",
            fontSize: "2.2rem",
            fontWeight: "700",
            color: "#111",
          }}
        >
          Privacy Policy
        </h1>

        <p style={{ color: "#666", marginBottom: "30px" }}>
          Speak Bold with KK • Version {TERMS_VERSION}
        </p>

        <p>
          At <strong>Speak Bold with KK</strong>, we are committed to protecting
          your personal information. This Privacy Policy explains how we collect,
          use, and secure your data when you use our website, mobile
          application, or services.
        </p>

        {/* Section 1 */}
        <h2 style={sectionTitleStyle}>Information We Collect</h2>
        <ul style={listStyle}>
          <li>Name</li>
          <li>Email address</li>
          <li>Usage data for improving services</li>
          <li>Payment information (processed securely by Razorpay)</li>
        </ul>

        {/* Section 2 */}
        <h2 style={sectionTitleStyle}>How We Use Your Information</h2>
        <ul style={listStyle}>
          <li>To create and manage your account</li>
          <li>To provide online sessions and premium content</li>
          <li>To improve our services and learning experience</li>
          <li>To send updates, confirmations, and notifications</li>
        </ul>

        {/* Section 3 */}
        <h2 style={sectionTitleStyle}>Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your
          personal information. We do not sell or share your data with any third
          party, except trusted service providers required to operate Speak Bold
          with KK.
        </p>

        {/* Section 4 */}
        <h2 style={sectionTitleStyle}>Third-Party Payment Processing</h2>
        <p>
          All payments are securely processed through <strong>Razorpay</strong>.
          Razorpay may collect information under their own privacy policy.
        </p>

        {/* Section 5 */}
        <h2 style={sectionTitleStyle}>Changes to This Policy</h2>
        <p>
          We may update this policy periodically. Continued use of our services
          indicates acceptance of the updated policy.
        </p>

        {/* Section 6 */}
        <h2 style={sectionTitleStyle}>Contact Us</h2>
        <p>
          For any questions regarding this Privacy Policy, you can contact us
          at:
        </p>

        <div
          style={{
            backgroundColor: "#f9fafc",
            padding: "20px",
            borderRadius: "8px",
            marginTop: "15px",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <strong>Email:</strong> support@speakboldwithkk.com
          </p>
          <p style={{ margin: "5px 0" }}>
            <strong>Location:</strong> Maihar, Madhya Pradesh, India
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            marginTop: "40px",
            paddingTop: "20px",
            borderTop: "1px solid #eee",
            fontSize: "0.9rem",
            color: "#888",
          }}
        >
          Last Updated: {new Date().getFullYear()} <br />©{" "}
          {new Date().getFullYear()} Speak Bold with KK. All rights reserved.
        </div>
      </div>
    </div>
  );
};

const sectionTitleStyle = {
  marginTop: "35px",
  fontSize: "1.4rem",
  fontWeight: "600",
  color: "#222",
};

const listStyle = {
  paddingLeft: "20px",
  marginTop: "10px",
};

export default PrivacyPolicy;